/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext, useMemo } from 'react';
import styled from 'styled-components';
import { ContactImportance } from '@bb/users';
import { TeamContext } from 'contexts';
import { Select, UserSelect, Text, Title } from 'components';
import ContactModalContext from './ContactModalContext';

const Details: React.FC = () => {
  const { targetTeamState, contacts, teamMemberList } = useContext(TeamContext);
  const { contact, modeType, setContact } = useContext(ContactModalContext);
  const contactIds = useMemo(
    () => contacts.map(({ contactId }) => contactId),
    [contacts],
  );

  return (
    <StyledContainer>
      <div>
        <Select
          label="Contact Status"
          required
          value={contact?.importance}
          onChange={importance => setContact({ ...contact!, importance })}
          options={Object.values(ContactImportance).map(value => ({
            label: value,
            value,
          }))}
          getPopupContainer={node => node.parentElement}
        />
        {modeType === 'edit' ? (
          <div>
            <Text strong dataCy={'select-agent-title'}>
              Select Agent
            </Text>
            <Title level={2} data-cy={'agent-name-title'}>
              {contact!.firstName} {contact!.lastName}
            </Title>
          </div>
        ) : (
          <UserSelect
            showSearch
            suppressInitialFetch
            optionLabelProp="label"
            teamMembers={teamMemberList}
            label="Select Agent"
            value={[contact!.contactId]}
            filter={({ id }) => (
                targetTeamState.users.some(user => user.id === id) &&
                !contactIds.includes(id)
              )}
            onChange={([contactId]) =>
              setContact({
                ...contact!,
                contactId,
                ...teamMemberList.find(member => member.id === contactId),
              })
            }
            getPopupContainer={node => node.parentElement}
          />
        )}
      </div>
    </StyledContainer>
  );
};

export default Details;

const StyledContainer = styled.div`
  grid-row: 1 / span 2;
  & > div {
    display: grid;
    gap: 16px;
  }
`;
